import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isAuthorized: false,
    isActivated: false,
    storeKey: '',
    phoneNumber: '',
    order: {},
    timeSpent: 0,
    timeout: '',
    timeoutTime: 45000, //45000
  },
  mutations: {

  },
  actions: {

  },
});
